<script setup lang="ts">
import type { SectionCanvasXpRecord } from '~/types/datocms'

const props = defineProps<{
  data: SectionCanvasXpRecord
  moduleIndex: number
}>()

const { invertedStyles } = useSectionRules(props.moduleIndex, props.data.invertColorTheme)

enum CanvasComponents {
  Demo = 'CanvasDemo',
  Rocket = 'CanvasRocket',
  Clients = 'CanvasClients',
  Work = 'CanvasWork',
  ClientsHome = 'CanvasClientsHome',
  Blob = 'CanvasBlob'
}

const appConfig = useAppConfig()

function resolveThreeComponent(key: keyof typeof CanvasComponents) {
  const componentName = CanvasComponents[key]
  return resolveComponent(componentName)
}
</script>

<template>
  <component
    :is="resolveThreeComponent(props.data.canvasName as keyof typeof CanvasComponents)"
    :data="props.data"
    :enabled="appConfig.ui?.enable3D"
    :class="invertedStyles"
  />
</template>
